var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHelp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.813 0 0 3.813 0 8.5S3.813 17 8.5 17 17 13.187 17 8.5 13.187 0 8.5 0m0 16C4.364 16 1 12.636 1 8.5S4.364 1 8.5 1 16 4.364 16 8.5 12.636 16 8.5 16m1.158-3.781a1.032 1.032 0 1 1-2.064-.002 1.032 1.032 0 0 1 2.064.002m1.004-8.004c.448.565.674 1.328.55 1.855-.243 1.027-.842 1.567-1.371 2.043-.543.489-.934.84-.934 1.647h-1c0-1.251.671-1.856 1.264-2.39.461-.415.896-.807 1.066-1.529.034-.143-.039-.6-.36-1.005-.307-.389-.728-.586-1.248-.586-1.779 0-1.869 1.444-1.873 1.609l-1-.027c.024-.893.655-2.582 2.873-2.582.818 0 1.539.343 2.033.965"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/help.svg";